<template>
  <Header />
  <main>
    <router-view v-slot="{ Component, route }">
      <transition name="route" mode="out-in" appear>
        <div :key="route.path">
          <component :is="Component" :key="route.path"></component>
        </div>
      </transition>
    </router-view>
  </main>
  <Footer />
</template>
<script>
import Header from "@/components/PartsHeader.vue";
import Footer from "@/components/PartsFooter.vue";

//

export default {
  data() {
    return {};
  },
  components: {
    Header,
    Footer,
  },
};
</script>
<style lang="scss">
//fonts
html {
  font-family: $font;
  font-weight: 500;
  color: $fontcolor;
}
html,
body {
  font-size: 16px;
  @include sp {
    font-size: 14px;
  }
}
body {
  font-family: $font;
}
// transition
.route-enter-from {
  opacity: 0;
}
.route-enter-active,
.route-leave-active {
  transition: all 0.5s $easing;
}
.route-leave-to {
  opacity: 0;
}
</style>
